import {
	FormControl,
	FormLabel,
	ToggleButton,
	ToggleButtonGroup
} from '@mui/material';
import React, { useCallback } from 'react';

const hasValueAttr = (maybeObj: unknown) =>
	Object.prototype.hasOwnProperty.call(maybeObj, 'value');

type Props = {
	// eslint-disable-next-line react/require-default-props
	label?: string;
	setValue: (value: string) => void;
	options:
		| string[]
		| {
				value: any;
				label: JSX.Element | string;
		  }[];
	value: string;
};

const ToggleButtonGroupControl: React.FC<Props> = ({
	options = [],
	value,
	setValue,
	label,
	...props
}: Props) => {
	const onChange = useCallback(
		(_: any, v: any) => {
			if (v !== null) setValue(v);
		},
		[setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset">
			{label && <FormLabel component="legend">{label}</FormLabel>}
			<ToggleButtonGroup
				{...props}
				size="small"
				color="primary"
				value={value}
				exclusive
				onChange={onChange}
			>
				{options.map((option: any) => (
					<ToggleButton
						value={hasValueAttr(option) ? option.value : option}
						key={hasValueAttr(option) ? option.value : option}
					>
						{option.label}
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</FormControl>
	);
};

const MemoToggleButtonGroupControl = React.memo(ToggleButtonGroupControl);

export { MemoToggleButtonGroupControl as ToggleButtonGroupControl };
